import React, { FunctionComponent } from 'react';

import styles from './office.module.scss';

export interface IOfficeProps {
  name: string;
  address: string;
  phone: string;
  email?: string;
}

export const Office: FunctionComponent<IOfficeProps> = props => {
  const { name, address, email, phone } = props;

  return (
    <div className={styles.office}>
      <h3 className={styles.name}>{name}</h3>
      <div
        className={styles.address}
        dangerouslySetInnerHTML={{ __html: address }}
      />
      <p className={styles.phone}>{phone}</p>
      {email && <p className={styles.email}>{email}</p>}
    </div>
  );
};
